import { action, observable, makeObservable } from 'mobx';

import { uploader } from '@gem/modules/file-upload';
import { t } from '@gem/modules/i18n';
import { convertFileToBlobUrl } from '@gem/utils';

import { PayloadType } from 'APP/model/message/messageModel.types';
import { MessageError } from 'STORE/Messages/Message/ChatMessage/ChatMessages.types';

import { Payload } from '../Payload';

export class FilePayload extends Payload {
  fileName;
  fileSize;
  url;
  mimeType;
  userMentions;
  @observable comment;
  @observable uploadProgress = null;
  userFile;
  userFileBlobUrl;
  duration;

  static THUMBNAIL_MAX_WIDTH = 50;
  static THUMBNAIL_MAX_HEGHT = 50;
  static PREVIEW_MAX_WIDTH = 440;
  static PREVIEW_MAX_HEIGHT = 440;
  static MIN_QUOTE_WIDTH = 200;

  constructor(data) {
    super({ ...data, payloadType: PayloadType.File });

    makeObservable(this);

    this.fileName = data.fileName;
    this.fileSize = Number(data.fileSize);
    this.url = data.url;
    this.mimeType = data.mimeType;
    this.comment = data.comment;
    this.userMentions = data.userMentions;
    this.keyWord = data.keyWord;

    this.keyWords = data.keyWord ? [data.keyWord] : [];
    this.userFile = data.userFile || null;
    this.userFileBlobUrl = convertFileToBlobUrl(this.userFile);
  }

  toJSON() {
    return {
      ...super.toJSON(),
      fileName: this.fileName,
      fileSize: this.fileSize,
      url: this.url,
      mimeType: this.mimeType,
      comment: this.comment,
      userFile: this.userFile,
      userMentions: this.userMentions,
      keyWord: this.keyWord || null,
    };
  }

  get getTypeForSend() {
    return this.payloadType;
  }

  static calculatePreviewSize(width, height, maxWidth, maxHeight) {
    let ratio = width / height;

    if (ratio <= 0 || !isFinite(ratio)) {
      ratio = 1;
    }

    if (ratio > 1) {
      // wide
      return {
        width: maxWidth < width ? maxWidth : width,
        height: maxWidth < width ? Math.ceil(maxHeight / ratio) : height,
      };
    }

    return {
      width: maxHeight < height ? Math.ceil(maxWidth * ratio) : width,
      height: maxHeight < height ? maxHeight : height,
    };
  }

  get isLoaded() {
    return this.url;
  }

  get typeDescription() {
    return t('message_desctription_file');
  }

  delete = async () => {
    const res = await this.message.delete();
    this.isDeleted = res;

    return res;
  };

  @action
  setUploadProgress = (value) => {
    this.uploadProgress = value;
  };

  @action
  cancelUploadAndDeleteMessage = async () => {
    const res = await this.delete();
    if (res) {
      this.cancelUploadFile();
    }
  };

  cancelUploadFile() {
    uploader.cancelUploadFile(this.uploadUrl);
  }

  @action
  async upload() {
    this.setUploadProgress(0);
    if (!this.isLoaded) {
      try {
        const { uploadUrl, publicUrl, headers } = await uploader.getUploadUrlData(
          this.fileName,
          this.userFile?.type || this.mimeType
        );

        if (!uploadUrl || this.isDeleted) {
          throw Error('uploadUrl not received');
        }

        this.uploadUrl = uploadUrl;
        await uploader.uploadFile(uploadUrl, this.userFile, this.fileName, headers, (event) => {
          this.setUploadProgress((event.loaded / event.total) * 100);
        });

        this.url = publicUrl;
      } catch (e) {
        this.setUploadProgress(0);
        this.message.setError(MessageError.Send);
        return;
      }
    }
    this.setUploadProgress(null);
  }
}
